const appsConfig = process.env.NODE_ENV === 'production' ? require('./appsConfig.prod') : require('./appsConfig.dev');
module.exports = {
  ...appsConfig,
  BLOG_APP_ID: '14bcded7-0066-7c35-14d7-466cb3f09103',
  PAID_PLANS_APP_ID: '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3',
  PAID_PLANS_SECTION_ID: 'membership_plan_picker_tpa'
};